export const normalizePhoneNumber = (countryCode = "", phoneNumber = "") => {
  const compactNumber = String(phoneNumber).trim().replace(/[\s().-]/g, "");

  if (!compactNumber) {
    return "";
  }

  if (compactNumber.startsWith("+")) {
    return compactNumber;
  }

  if (compactNumber.startsWith("00")) {
    return `+${compactNumber.slice(2)}`;
  }

  const compactCountryCode = String(countryCode).trim();
  const nationalNumber = compactNumber.replace(/^0+/, "");

  return `${compactCountryCode}${nationalNumber}`;
};
